import React, { useEffect } from "react";
import style from "./LinksAndQRCodesView.module.scss";
import { LinksAndQRCodesViewBloc, QRCodeViewState } from "./LinksAndQRCodesViewBloc";
import { useCreation } from "ahooks";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import func from "@uikit/func";
import cls from "classnames";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { CopyLInkIcon } from "../PreviewHeader/icons/CopyLInkIcon";
import useFeatureTags from "@custom-hooks/useFeatureTags";
// 组件类型定义
interface LinksAndQRCodes {
  url: string;
  title: string;
  uuid: string;
}

// 组件
const LinksAndQRCodesView: React.FC<LinksAndQRCodes> = ({ url, title, uuid }) => {
  const qrCodeState = new QRCodeViewState();
  const bloc = useCreation(() => new LinksAndQRCodesViewBloc(qrCodeState), []);

  const handleClick = () => {
    bloc.clickClose();
  };

  const featureTags = useFeatureTags();

  const clickStop = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
  };

  useEffect(() => {
    if (bloc.state.isQRCodeBox.value) {
      document.addEventListener("click", handleClick);
    }

    return () => {
      // 在组件卸载时移除事件监听器
      document.removeEventListener("click", handleClick);
    };
  }, [bloc.state.isQRCodeBox.value]);
  const isClickable = !func.isEmpty(url) && !bloc.state.isQRCodeBox.value;
  const group = `${settings.S3CDN}${settings.viewAssetsPath}${isClickable ? "group-blue" : "group"}.svg`;
  const link = `${settings.S3CDN}${settings.viewAssetsPath}${isClickable ? "link-arrow-blue" : "link-arrow"}.svg`;
  const copy = `${settings.S3CDN}${settings.viewAssetsPath}${isClickable ? "copy-blue" : "copy"}.svg`;
  const QRIcon = `${settings.S3CDN}${settings.viewAssetsPath}group.svg`;

  const antIcon = <LoadingOutlined style={{ fontSize: 20 }} spin />;
  const enablePublishV3 = featureTags.enablePublishV3;

  return (
    <div className={`${enablePublishV3 ? style.linksAndCodesBox : style.originBox}`} data-testid="linksAndCodesBox">
      {enablePublishV3 ? (
        <>
          <div onClick={() => bloc.copyShareLink(url, uuid)}>
            <CopyLInkIcon />
            <span className={style.copyLinkTxt}>Copy link</span>
          </div>
          <div className={style.orLine}></div>
          <img
            src={QRIcon}
            width="20"
            alt="icon"
            onClick={() => {
              bloc.getStudioDomainList(url, title);
            }}
          />

          {bloc.state.isQRCodeBox.value && (
            <div className={style.QRCodeModeBox} onClick={e => clickStop(e)} data-testid="QRCodeMode">
              <div onClick={() => bloc.clickClose()} className={style.maskBox}></div>

              <div className={style.QRCodeBox}>
                <div className={style.codeTitle}>{bloc.state.titleStr.value}</div>
                <img
                  className={style.crossBox}
                  onClick={() => bloc.clickClose()}
                  src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`}
                  width="20"
                  alt="icon"
                />
                <img className={style.codeBox} src={bloc.state.qrCodeUrl.value} width="240" alt="icon" />
                <div className={style.codeText}>Preview on mobile device</div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className={style.urlInput} onClick={() => bloc.copyShareLink(url, uuid)}>
            <img src={copy} width="20" alt="icon" />
            <div className={cls(style.urlText, isClickable ? style.clickable : "")}>{url}</div>
            <img onClick={e => bloc.clickToShare(e, url)} src={link} width="20" alt="icon" />
          </div>

          <div
            className={style.urlCodes}
            onClick={() => {
              bloc.getStudioDomainList(url, title);
            }}
          >
            {bloc.state.codeLodaing.value ? <Spin indicator={antIcon} /> : <img src={group} width="20" alt="icon" />}
          </div>

          {bloc.state.isQRCodeBox.value && (
            <div className={style.QRCodeModeBox} onClick={e => clickStop(e)} data-testid="QRCodeMode">
              <div onClick={() => bloc.clickClose()} className={style.maskBox}></div>

              <div className={style.QRCodeBox}>
                <div className={style.codeTitle}>{bloc.state.titleStr.value}</div>
                <img
                  className={style.crossBox}
                  onClick={() => bloc.clickClose()}
                  src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`}
                  width="20"
                  alt="icon"
                />
                <img className={style.codeBox} src={bloc.state.qrCodeUrl.value} width="240" alt="icon" />
                <div className={style.codeText}>Preview on mobile device</div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LinksAndQRCodesView;
